/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

function bookmakers(state = global.__PRELOADED_STATE.bookmakers) {
    return state;
}

/**
 * Bookmakers reducer
 */
export default bookmakers;



// WEBPACK FOOTER //
// ./src/js/Bookmakers/bookmakers.reducer.js